const digit = /\d/;
const dmy = /[dmy]/i;
const isDigit = c => dmy.test(c);

export default format => format.split("").map(c => (isDigit(c) ? digit : c));
